import { AbstractPmsApiService } from '../abstract.service';
import { PaymentVoucher } from '../../models';
import { Property } from '../../models';
import { mapGetToPostParams } from '../../../app/helpers';

/**
 * @class PaymentVoucherPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService}
 */
export class PaymentVoucherPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/vouchers/payment(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {PaymentVoucher}
     * @protected
     */
    newModel(attributes, ...params) {

        return new PaymentVoucher(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<PaymentVoucher>>}
     */
    get (params = {}, property = null) {

        const url = this.url({
            propertyId: property ? property.id : 0
        });

        return this.http
            .post(url, mapGetToPostParams(params), {
                headers: this.authHeaders,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    viewPdf(voucherId, propertyId, params = {}) {
        const url = this.url({propertyId, id: voucherId}) + '/view-pdf';

        return this.http.get(url, {
            headers: this.authHeaders,
            responseType: 'blob',
            params,
        });
    }

    summary(params = {}, property) {
        const url = this.url({
            propertyId: property.id
        }) + '/summary';

        return this.http.get(url, {
            headers: this.authHeaders,
            params,
        }).then(this.getDataExtractor());
    }

    exportExcel(params = {}, property) {
        const url = this.url({
            propertyId: property.id
        }) + '/export-excel';

        return this.http.get(url, {
            headers: this.authHeaders,
            responseType: 'blob',
            params,
        });
    }

    /**
     * @param {Object.<string, *>} paginationData
     * @param {...*} params
     * @returns {PaginationCollection<M>}
     * @protected
     */
    newPaginationCollection(paginationData, ...params) {
        const pagination = super.newPaginationCollection(paginationData, ...params);
        pagination['totalAmount'] = paginationData.total_amount;

        return pagination;
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/vouchers/payment-voucher.service.js